import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";

// Content
import Introduction from "./content/Introduction";
import Hobbies from "./content/Hobbies";
import About from "./content/Skills";
import Education from "./content/Education";
import Experience from "./content/Experience";
import Previouswork from "./content/Previouswork";

// Styles
import "./assets/Main.scss";

export default function Page() {
  const [showNavigation, setIsShown] = useState(false);
  const navRef = useRef(null);
  const navToggleRef = useRef(null);

  useEffect(() => {
    const isDesktop = window.innerWidth >= 1024;
    setIsShown(isDesktop);

    const handleClickOutside = (event) => {
      const isMobile = window.innerWidth < 1024;

      if (
        isMobile &&
        navRef.current &&
        !navRef.current.contains(event.target) &&
        navToggleRef.current &&
        !navToggleRef.current.contains(event.target)
      ) {
        setIsShown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
  }, []);

  const toggleNavigation = () => {
    setIsShown((prev) => !prev);
  };

  return (
    <div id="page">
      <Router>
        <Header
          onToggleNavigation={toggleNavigation}
          isNavOpen={showNavigation}
          navToggleRef={navToggleRef}
        />
        <div className="navigationAndContent">
          <div ref={navRef}>
            <Navigation isShown={showNavigation} />
          </div>
          <div className="content">
            <Routes>
              <Route path="/" element={<Introduction />} exact />
              <Route path="/about" element={<About />} />
              <Route path="/hobbies" element={<Hobbies />} />
              <Route path="/experience" element={<Experience />} />
              <Route path="/previouswork" element={<Previouswork />} />
              <Route path="/education" element={<Education />} />
            </Routes>
          </div>
        </div>
      </Router>
      <Footer />
    </div>
  );
}
